import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Button, Divider } from 'antd';
import './NewsDetail.css';

export default function NewsDetail(props) {
  const { pageName } = useParams();
  const location = useLocation();
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const {lang} = props;
  const backHref = lang ? '/news_en' : '/news_cn';

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlParam = searchParams.get('url');
    const titleParam = searchParams.get('title');

    if (titleParam) {
      setTitle(titleParam);
    }

    let fetchUrl;
    if (urlParam) {
      fetchUrl = urlParam;
    } else {
      fetchUrl = `/datas/newsContents/${pageName}/${pageName}.html`;
    }

    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(data => {
        setContent(data);
      })
      .catch(error => {
        console.error('Error fetching news detail:', error);
      });
  }, [lang, pageName, location.search]);
  

  return (
    <div className="news_detail_container">
      {title && <h2 className="news-detail-title" style={{ textAlign: 'center', margin: '20px 0' }}>{title}</h2>}
      <Divider/>
      <div className="news-content" dangerouslySetInnerHTML={{ __html: content }} />
      <p></p>
      <Button type="primary" href={backHref} style={{ margin: 'auto' }}>返回</Button>
    </div>
  );
}